/* eslint-disable */
import React, { useContext, useEffect, useState } from 'react';
import { dofStyles } from '../JSStyles/dofStyles';
import DOFHeader from './Header';
import {
    Grid,
    Typography,
    RACModalCard,
    RACButton
} from '@rentacenter/racstrap';
import { IdentityContext } from '../context/userInformation/IdentityContextProvider';
import { useHistory } from 'react-router-dom';
import DocumentCapture from '../common/camera/OpenCamera';
import MessagePopup from '../common/MessagePopup';
import FileToPDFViewer from '../common/FileToPDFViewer';
import { handleFile, uploadDocuments } from '../common/helperFunction/HelperFunction';
import ScreenLoader from '../common/loader/ScreenLoader';
import { ReactComponent as UploadIcon } from './../images/uploadImage.svg';
import { ReactComponent as ImageIcon } from './../images/image-icon.svg';
import { ReactComponent as PdfIcon } from './../images/pdf-icon.svg';
import { ReactComponent as DeleteIcon } from './../images/delete-icon.svg';

import {
    ACCEPTED_FILE_TYPES,
    SIZE_UNIT_KB,
    SIZE_UNIT_MB,
    SIZE_UNIT_GB,
} from '../constants/constants';
import { useTranslation } from 'react-i18next';
import { CreateCustomerStg } from '../api/user';
import { StgIdentityRecord } from '../interface/CustomerInformationInterface';





const SelfieUpload: React.FC = () => {
    const history = useHistory();
    const { t } = useTranslation();
    const classes: any = dofStyles();
    let dofAuthSessionValue: any = window.sessionStorage.getItem("dofAuthValues");
    let sessionStorageValues: any = JSON.parse(dofAuthSessionValue);
    const featureFlagDetailsString: any = window.sessionStorage.getItem("featureFlagDetails");
    const featureFlagDetail: any[] = featureFlagDetailsString ? JSON.parse(featureFlagDetailsString) : [];
    const canEnableCountryCode = featureFlagDetail.find((param: { paramKeyName: string; }) =>
        param.paramKeyName === 'CountryCode');
    const enableSecondName = featureFlagDetail.find((param: { paramKeyName: string; }) =>
        param.paramKeyName === 'MXStoreIdentifier');


    const context = useContext(IdentityContext);
    if (!context) {
        return <div> {t("Application is not available")}</div>;
    }

    const {
        showSelfieDocument, setShowSelfieDocument,
        selfieDoc,
        setSelfieDoc,
        fileSize,
        setFileSize,
        fileType,
        setFileType,
        stgCustomerProfileId,
        setLiveLinessCompleted,
        getStgCustomerRes,
        customerId,
        identityInformation
    } = context;



    const [openPdf, setOpenPdf] = useState<boolean>(false);
    const [errorMessage, setErrorMessage] = useState<string>('');
    const [messagePopup, setMessagePopup] = useState<boolean>(false);
    const [screenLoader, setScreenLoader] = useState<boolean>(false);


    // Function for uploading the document:

    const UploadSelfieDocument = async () => {
        let documentbase64data: any;
        let documentsToUpload = [];
        let uploadDocResponse: any;


        try {
            setScreenLoader(true)

            if (selfieDoc) {
                documentbase64data = await handleFile(selfieDoc);
                console.log("selfieDocselfieDoctest", selfieDoc)
                console.log("documentbase64datatest", documentbase64data)
                // Check if documentFrontData exists and push to the array
                if (documentbase64data) {
                    documentsToUpload.push({
                        documentType: 'SELFIE',
                        file: documentbase64data?.base64String,
                    });
                }
                uploadDocResponse = await uploadDocuments(Number(stgCustomerProfileId) ? stgCustomerProfileId : stgCustomerProfileId, documentsToUpload, null);
                const filtered: StgIdentityRecord[] = getStgCustomerRes?.identityInfo?.filter(
                      (item: StgIdentityRecord) => item.livenessChecked === 0
                    ) ?? [];
                const agreementFiltered: StgIdentityRecord[] = sessionStorageValues?.agreementId
                      ? filtered.filter(
                          (item: StgIdentityRecord) =>
                            item.agreementId != null &&
                            String(item.agreementId) === String(sessionStorageValues?.agreementId)
                        )
                      : [];
                    const recordsToSearch: StgIdentityRecord[] =
                      agreementFiltered.length > 0 ? agreementFiltered : filtered;
                
                    const latestRecord =  recordsToSearch?.reduce(
                      (latest: StgIdentityRecord, current: StgIdentityRecord) =>
                        new Date(current.transactionDate) > new Date(latest.transactionDate)
                          ? current
                          : latest,
                      recordsToSearch[0]
                    );
                //   Payload for updating the Liveliness check
                const stgCustomerPayload = {
                    stgCustomerProfileId: Number(stgCustomerProfileId) ? stgCustomerProfileId : undefined,
                    action: Number(stgCustomerProfileId) ? "UPD" : "CRT",
                    firstName: identityInformation.firstName || '',
                    middleInitial: identityInformation.secondName || '',
                    lastName: identityInformation.paternalLastName || '',
                    maternalLastName: identityInformation.maternalLastName || '',
                    gender: identityInformation?.gender ? identityInformation?.gender.toUpperCase() : '',
                    dob: identityInformation.dateOfBirth || '',
                    maritalStatus: identityInformation.maritalStatus || '',
                    phoneNumber: identityInformation.phoneNumber ? identityInformation.phoneNumber.replace(/\D/g, '') : '',
                    countryCode: canEnableCountryCode?.paramValue == '1' ? identityInformation.countryCode : undefined,
                    emailId: identityInformation.emailId || '',
                    referralSources: identityInformation.racPromotions || '',
                    phoneType: 'CELL',
                    callTime: 'MORN',
                    submittedDate: new Date().toISOString().split('T')[0],
                    storeNumber: window.sessionStorage.getItem('storeNumber'),
                    productCode: sessionStorageValues?.productCode || getStgCustomerRes?.productCode || undefined,
                    customerCreatedSource: sessionStorageValues?.clientId || getStgCustomerRes?.customerSource || undefined,
                    customerId: sessionStorageValues?.type == 'EC' ? sessionStorageValues?.identifier : undefined,
                    consentDate: getStgCustomerRes?.consentDate || null,
                    identityInfo: {
                        curpId: identityInformation.curp,
                        voterId: identityInformation.ineVoterid,
                        rfcId: identityInformation.rfc,
                        transactionGuid: latestRecord && latestRecord?.transactionGuid || null,
                        transactionDate: latestRecord?.transactionDate || new Date().toISOString(),
                        livenessChecked: 1,
                        stgCustomerIdentityId: latestRecord && latestRecord?.stageCustomerIdentityId ? String(latestRecord?.stageCustomerIdentityId) : undefined,
                        identityVerificationStatus: latestRecord?.identityVerification == "APPROVED" && Number(stgCustomerProfileId) ? 'APPROVED' : 'PENDING',
                        idValidationType: latestRecord && latestRecord?.idValidationType ? latestRecord?.idValidationType : 'MANUAL',
                        selfieValidationType: 'MANUAL'
                    },
                };
                const isStoreCodeFlow = window.sessionStorage.getItem('authKey')?.length ? false : true;
                const accessToken = isStoreCodeFlow ? window.sessionStorage.getItem('storeNumber') : window.sessionStorage.getItem('authKey');
                const response: any = await CreateCustomerStg(stgCustomerPayload, isStoreCodeFlow, accessToken)

                setScreenLoader(false)
                if (uploadDocResponse == 200 && response?.status == 200) {
                    setLiveLinessCompleted(true)
                    history.push('/submission');
                }
            }
        }
        catch (error: any) {
            setScreenLoader(false)
        }


    }

    const pdfModelContent = () => {
        return <FileToPDFViewer file={selfieDoc} />;
    };
    // Handle file input changes
    const handleFileChange = (event: React.ChangeEvent<HTMLInputElement>) => {
        const files = event.target.files;
        if (files) {
            handleFiles(Array.from(files));
        }
    };
    // Handle file drop event
    const handleDrop = (event: React.DragEvent<HTMLDivElement>) => {
        event.preventDefault();
        console.log('handleDrop', event.dataTransfer.files);
        handleFiles(Array.from(event.dataTransfer.files));
    };

    // Process selected files
    const handleFiles = async (files: File[]) => {
        const validFiles = files.filter((file) =>
            ACCEPTED_FILE_TYPES.includes(file.type)
        );

        // Convert each file into a Base64 string
        const base64Promises = validFiles.map((file) => convertToBase64(file));
        const base64Results = await Promise.all(base64Promises);
        handleFileDetails(files);
    };

    const convertToBase64 = (file: File): Promise<string> => {
        return new Promise((resolve, reject) => {
            const reader = new FileReader();
            reader.onload = () => resolve(reader.result as string);
            reader.onerror = () => reject(new Error('Failed to convert file.'));
            reader.readAsDataURL(file);
        });
    };

    const handleFileDetails = (files: any) => {
        const fileSizeInBytes = files[0].size;
        setFileType?.(files[0].type);
        setSelfieDoc?.(files[0]);

        let fileSize: any = fileSizeInBytes;
        let sizeUnit = 'bytes';

        if (fileSizeInBytes >= 1024) {
            fileSize = fileSizeInBytes / 1024;
            sizeUnit = SIZE_UNIT_KB;
        }
        if (fileSize >= 1024) {
            fileSize = fileSize / 1024;
            sizeUnit = SIZE_UNIT_MB;
        }
        if (fileSize >= 1024) {
            fileSize = fileSize / 1024;
            sizeUnit = SIZE_UNIT_GB;
        }

        fileSize = fileSize.toFixed(2);
        setFileSize?.(`${fileSize} ${sizeUnit}`);

        const isAcceptedType = ACCEPTED_FILE_TYPES.includes(files[0].type);
        // const isPdf = files[0].type === 'application/pdf';
        const fileSizeNumber = Number(fileSize);

        if (!isAcceptedType) {
            setMessagePopup(true);
            setErrorMessage(
                'Invalid file format. Please upload a PDF, JPEG, or PNG.'
            );
            setSelfieDoc?.('');
            return;
        }

        if (sizeUnit === SIZE_UNIT_KB) {
            setShowSelfieDocument?.(true);
            return;
        }

        if (sizeUnit === SIZE_UNIT_MB && fileSizeNumber >= 5) {
            setMessagePopup(true);
            setErrorMessage('Please upload a file smaller than 5MB.');
            setSelfieDoc?.('');
            return;
        }

        if (
            (sizeUnit === SIZE_UNIT_MB && fileSizeNumber > 20) ||
            sizeUnit === SIZE_UNIT_GB
        ) {
            setMessagePopup(true);
            setErrorMessage('Please upload a file smaller than 20MB.');
            setSelfieDoc?.('');
            return;
        }

        setShowSelfieDocument?.(true);
    };
    function renderUploadedDocument() {
        return (
            <Grid
                style={{
                    width: '100%',
                    textAlign: 'left',
                    padding: '10px',
                    display: 'flex',
                    paddingTop: '0px',
                    cursor: 'pointer',
                }}
            >
                {fileType &&
                    (fileType === 'image/png' || fileType === 'image/jpeg') && (
                        <ImageIcon style={{ width: '20px', height: '20px' }} />
                    )}
                {fileType && fileType === 'application/pdf' && (
                    <PdfIcon style={{ width: '20px', height: '20px' }} />
                )}
                <Typography
                    className={`${classes.primaryFontColor} ${classes.pl10px}`}
                    onClick={() => {
                        setOpenPdf(true);
                    }}
                >
                    {t("Proof of Selfie")}{' '}
                    <span className={`${classes.fileSizeColor}`}>{fileSize}</span>
                </Typography>
                <DeleteIcon
                    style={{
                        width: '15px',
                        height: '15px',
                        marginLeft: '10px',
                        marginTop: '3px',
                    }}
                    onClick={() => {
                        setShowSelfieDocument?.(false);
                        setSelfieDoc?.('');
                    }}
                />
                <RACModalCard
                    borderRadius="15px"
                    closeIcon={true}
                    isOpen={openPdf}
                    maxWidth={'sm'}
                    className={`${classes.customModal}`}
                    title={t(`Proof of Selfie`)}
                    onClose={() => setOpenPdf(false)}
                >
                    {pdfModelContent()}
                </RACModalCard>
            </Grid>
        );
    }

    return (
        <Grid >
            {screenLoader ? <ScreenLoader /> : false}

            <DOFHeader
                identity={true}
                residence={true}
                income={false}
                reference={false}
                activeStep="Income"
            />
            {messagePopup ? (
                <MessagePopup
                    value={{
                        message: errorMessage,
                        setFunction: setMessagePopup,
                        cleanupFunction: setErrorMessage,
                    }}
                />
            ) : null}
            <Grid style={{ marginTop: "7%" }}>




                <Typography
                    className={`${classes.primaryFontColor} ${classes.responsiveFontTitle} ${classes.boldFont1} ${classes.p10px}`}
                    style={{ textAlign: 'center' }}

                >
                    {t("Liveliness Check")}

                </Typography>

                <Grid style={{ textAlign: 'center' }}>
                    <Typography
                        className={`${classes.responsiveFont14px} ${classes.p10px} ${classes.responsiveText}`}
                        style={{ textAlign: 'center', margin: '0 auto' }}
                    >
                        {t("Please upload or take a clear photo of your face to continue with the liveliness verification process.")
                        }
                    </Typography>

                </Grid>

                {/* Document Upload */}
                <Grid style={{
                    marginTop: '65px', display: 'flex', justifyContent: 'space-around',
                }}>
                    <Grid style={{ minWidth: '30%', maxWidth: '36%' }}>
                        <DocumentCapture
                            setResidenceDoc={setSelfieDoc}
                            setFileSize={setFileSize}
                            setFileType={setFileType}
                            selfieImage={true}
                            setShowSelfieDocument={setShowSelfieDocument}
                            isSelfieCapture={true}
                        />
                    </Grid>
                </Grid>

                {/* Showing the Document */}
                {showSelfieDocument && renderUploadedDocument()}

                <Grid style={{ float: 'right', marginTop: '10rem', padding: '35px' }}>
                    <RACButton
                        variant="contained"
                        color="primary"
                        style={{
                            padding: '12px 30px',
                            borderRadius: '5px',
                            marginTop: '25px',
                        }}
                        onClick={() => {
                            UploadSelfieDocument();
                        }}
                    >
                        {t("Save")}
                    </RACButton>
                </Grid>

            </Grid>
        </Grid>
    );
};
export default SelfieUpload;
